<template>
    <div class="proLinkBox">
        <div class="links">
            <div class="linkTitle"><b>Learn more</b></div>
            <div style="padding-top:12px;color:#fff;">
              
              <!-- {{catalogLinkData}}<br/> -->
              <!-- {{linksData}}<br/> -->

                <template v-if="linksData && linksData.length>0">
                  <a :href="item.url" 
                      class="boxLink"
                      target="_blank" v-for="item in linksData" :key="item.title">
                    {{item.title}}
                  </a>
                </template>
                <template v-else>
                  <!-- no real data: show dummy elements -->
                  <a href="">MIS LYNX Catalog*</a>
                  <a href="">MIS LYNX Flyer</a>
                  <a href="">Conical Connection Product Catalog</a>
                  <a href="">MIS LYNX Prosthetic Options</a>
                </template>
            </div>
        </div>        
        <a class="btn" :href="getCatalogLink">{{getCatalogLinkTitle}}</a>
    </div>      
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  components: {  },
  data() {
    return {
        items:[
        ]
    };
  },
  props: {
    sectionData:{},
    catalogLinkData:{},
    linksData:[]
  },
  computed: {
    ...mapGetters(["localeString"]),
    getCatalogLink()
    {
        if(this.catalogLinkData && this.catalogLinkData.url.length>0){
          return this.catalogLinkData.url;
        }else{
          return "https://mis-implants.com/product-catalog";//<<<default when no data exist
        }
    },
    getCatalogLinkTitle()
    {
        if(this.catalogLinkData && this.catalogLinkData.title.length>0){
          return this.catalogLinkData.title;
        }else{
          return "View Products";//<<<default when no data exist
        }
    }    
  },
  methods: 
  {
    //...mapActions(["setGalleryIndex", "setGalleryChildren"]),


  }
};
</script>

<style scoped>

    .proLinkBox
    {      
      width: 100%;
      min-height: 10vw;      
      margin: auto;
      border-radius: 18px;
      padding: 40px 40px 45px 40px;
      background-color:#1894e2;color: #fff;
      /* border: solid 1px #202020;backdrop-filter: blur(5px); */
    }
    .proLinkBox .btn
    {
        
        font-weight: 500 !important;
        border-radius: 30px;
        padding: 10px 20px;
        /* border: solid 2px #202020;  color: #202020;     */
        border: solid 2px #fff;  
        color: #fff;
        font-size: 12px;
    }
    .proLinkBox .links
    {
      display: block;
      padding-bottom: 25px;
    }
    .proLinkBox .links a
    {
      color: #fff;
      font-size: 12px;
      font-weight: 300 !important;
      opacity: 0.8;
      display: block;
      padding-bottom: 8px;
    }
    .proLinkBox .links .linkTitle
    {
      font-size: 18px !important;
    }


    @media (hover: hover) {
      .proLinkBox .links a:hover
      {
        opacity: 1;
      }

    }

    @media screen and (max-width: 815px)
    {
    }

    @media only screen and (min-width:2000px)
    {
    }
</style>
